import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoLink from "../assests/public/login-bg.png";
import logolink2 from "../assests/public/trezi_logo.png"
import "./loginstyle.css";
import { Row, Col, Navbar } from "react-bootstrap";
import { Container, Box, Typography, TextField, Button, FormControl, InputAdornment, IconButton, InputLabel, Grid } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { baseUrlUser } from "../utils/common";
import { getCartValue } from "../services/ProductsService";

const url = baseUrlUser;

const getCookieValue = (name) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
};

const Login = ({ checkAuthentication }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Login Page';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${url}users/login/product`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Product': 'Showcase'
        },
        credentials: 'include',
        body: JSON.stringify({
          email: email.toLowerCase(),
          password: password,
        })
      });

      if (!response.ok) {
        if (response.status === 400) setError("Invalid Login");
        else if (response.status === 403) setError("User is currently inactive.");
        else if (response.status === 404) setError("No account found with that email.");
        else setError("Please check login details again");
        return;
      }

      const data = await response.json();
      const { treziAccessToken, orgIdentifier, role, isSubscriptionActive } = data;

      if (!treziAccessToken) {
        setError("Invalid Login and Password");
        return;
      }

      // Set cookies & localStorage
      localStorage.setItem('email', email);
      localStorage.setItem('treziAccessToken', treziAccessToken);
      localStorage.setItem('organizationIdentifier', orgIdentifier);
      localStorage.setItem('role', role);

      document.cookie = `treziAccessToken=${treziAccessToken}; path=/; max-age=${7 * 24 * 60 * 60}`;
      document.cookie = `orgIdentifier=${orgIdentifier}; path=/; max-age=${7 * 24 * 60 * 60}`;
      document.cookie = `role=${role}; path=/; max-age=${7 * 24 * 60 * 60}`;

      // Ensure storage is flushed before continuing
      setTimeout(() => {
        checkAuthentication();

        // Role-based redirection
        if (role === "Finance_Manager") {
          navigate("/financeportal");
        } else if (role === "Owner" && !isSubscriptionActive) {
          navigate("/planbox");
        } else if (role === "Owner" && isSubscriptionActive) {
          navigate("/cdashboard");
        } else if (role === "Catalog_Manager" && isSubscriptionActive) {
          navigate("/cdashboard");
        } else if (role === "Catalog_Manager" && !isSubscriptionActive) {
          setError("User not active. Please contact your owner.");
        } else if (role === "Customer_Success_Manager") {
          navigate("/CustomerSuccessTable");
        } else if (role === "Sales" && isSubscriptionActive) {
          navigate("/sales-product-catalog");
        } else if (role === "Sales" && !isSubscriptionActive) {
          setError("User not active. Please contact your owner.");
        } else if (role === "Dashboard") {
          navigate("/trezi-dashboard");
        } else {
          setError("Check Login Details");
        }
      }, 0);
    } catch (error) {
      console.error("Error:", error);
      setError("Invalid email or password");
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <div className="box8">
      <Grid container>
        <Grid item>
          <Box className="box mt-0 mb-0" p={4}>
            <div>
              <img src={logolink2} alt="Logo" style={{ width: "100px" }} />
            </div>
            <Typography variant="h5" className="mt-2" component="h1" gutterBottom>
              Please, Login to continue
            </Typography>
            {error && <span className="text-danger mt-2">- {error}</span>}
            <Box component="form" onSubmit={handleSubmit} mt={3}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <InputLabel shrink>Email Address*</InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      variant="outlined"
                      required
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <InputLabel shrink>Password*</InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      variant="outlined"
                      required
                      value={password}
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowPassword}>
                              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Typography variant="body2" align="left" className="mt-2 custom-link">
                <Link to="/forgetPassword" className="text-reset">Forgot Password?</Link>
              </Typography>
              <Button
                className="mt-4"
                style={{ height: "55px", textTransform: "none" }}
                type="submit"
                variant="contained"
                fullWidth
              >
                Login Securely
              </Button>
              <Typography variant="subtitle2" align="left" mt={5} color="textSecondary">
                Don't have an account? <Link to="/signupboard">Sign Up</Link>
              </Typography>
              <Box mt={5}>
                <Typography variant="body2" align="left" className="mt-3 custom-link-anchor">
                  By logging into Trezi and its offerings, you agree to our <a href="https://trezi.com/terms-of-use/">Terms & Conditions</a> and <a href="https://trezi.com/privacy-policy/">Privacy Policy</a>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
